import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import TabsFormFonts from './TabsFormFont'
import TabsFormStyle from './TabsFormStyle'
import type { TabsFormBrandType, TabsBrandForms } from './tabsTypes'

const FORM_MAP: TabsBrandForms = {
  [BrandFormEnum.STYLE]: TabsFormStyle,
  ...TabsFormFonts,
}

const TabsFormBrand: TabsFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(TabsFormBrand) as typeof TabsFormBrand
